<div
  class="flex border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex-col gap-5 w-full"
>
  <ui-skeleton class="inline-block h-4 w-40 rounded-full" />

  <ui-alert>
    <div class="flex flex-col gap-1">
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
    </div>
  </ui-alert>
</div>
